<template>
  <div>
    <div :class="$style.box">
      <div :class="$style.mask" @touchmove.prevent></div>
      <div :class="$style.content">
        <div></div>
        <div></div>
        <div :class="$style.inner">
          <div :class="$style.top">兑换记录</div>
          <div :class="$style.bot">
            <div :class="$style.title">
              <p>时间</p>
              <p>奖品</p>
              <p>礼包码</p>
            </div>
            <div :class="$style.list">
              <div v-for="(item, index) in config" :key="index">
                <p>{{ item.created_at.substr(0, 10) }}</p>
                <p>{{ item.name }}</p>
                <p>{{ item.remark }}</p>
              </div>
            </div>
            <img @click="$emit('closeRecord')" :src="`${$cdnUrl}/freeKingdoms/button_close.png`" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DialogRecord',
  props: {
    config: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
};
</script>

<style lang='scss' module>
.box {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 10;
  overflow: hidden;
  .mask {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.6);
  }
  .content {
    width: 300px;
    height: 372px;
    // background-color: pink;
    position: absolute;
    left: 50%;
    top: 120px;
    transform: translateX(-50%);
    > div:nth-child(1) {
      width: 282px;
      height: 100%;
      border: 1px solid #c2a67a;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
    > div:nth-child(2) {
      width: 100%;
      height: 350px;
      border: 1px solid #c2a67a;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
    .inner {
      width: 293px;
      height: 364px;
      border: 1px solid #c2a67a;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
      background-color: #401f15;
      box-sizing: border-box;
      .top {
        width: 100%;
        height: 56px;
        background-color: #31170a;
        text-align: center;
        line-height: 56px;
        font-size: 23px;
        font-family: FZDaBiaoSong-B06S;
        font-weight: 400;
        color: #fff0b4;
      }
      .bot {
        width: 100%;
        height: 309px;
        position: relative;
        > img {
          width: 111px;
          position: absolute;
          left: 50%;
          bottom: 14px;
          transform: translateX(-50%);
        }
        .title {
          width: 100%;
          height: 34px;
          background: #503d39;
          display: flex;
          justify-content: space-between;
          > p {
            font-size: 15px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #d7bd7e;
          }
        }
        .list {
          width: 100%;
          height: 200px;
          overflow-y: auto;
          overflow-x: hidden;
          > div {
            width: 100%;
            height: 34px;
            display: flex;
            justify-content: space-between;
            font-size: 13px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #a38a7a;
            border-bottom: 0.5px solid #2a130c;
          }
        }
        p {
          width: 103px;
          line-height: 34px;
          text-align: center;
        }
      }
    }
  }
}
</style>